import { CountryEffects } from './country.effects';
export const effects: any[] = [CountryEffects];
